import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, ApiError } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface IdentityResponse {
  id: string;
  email: string;
  name: string;
  role: string;
  account_id: string | null;
  org_id: string;
  org_name: string;
  org_slug: string;
  created_at: string;
}

export interface MyApiKeyResponse {
  id: string;
  prefix: string;
  created_at: string;
  last_used_at: string | null;
  scopes: string[];
}

export function useMyApiKey() {
  const query = useQuery({
    queryKey: queryKeys.apiKeys.mine(),
    queryFn: async () => {
      try {
        return await api<MyApiKeyResponse | null>("/api/v2/api-keys/me");
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) return null;
        throw err;
      }
    },
  });

  const refetch = useCallback(() => {
    void query.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.refetch]);

  return {
    myKey: query.data ?? null,
    loading: query.isLoading,
    error: query.error ? "Failed to load API key" : "",
    refetch,
  };
}
